export default __webpack_public_path__ + "static/media/tmovie.5cabecb5.png";